<template>
  <div class="language-selector" v-if="locales && locales.length > 1">
    <a
      href="#"
      @click.prevent="toggleLangs"
      :style="{ color: color }"
      class="current-language"
      >Language: {{ currentLang.name }}<span class="triangle"></span
    ></a>
    <div class="language-options" v-if="show">
      <a
        :href="'?locale=' + locale.code"
        :style="{ color: color }"
        v-for="locale in availableLocales"
        :key="locale.code"
        v-once
        >{{ locale.name }}</a
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    locales: {
      type: Array,
      default: []
    },
    lang: {
      type: String,
      default: "eng"
    },
    color: {
      type: String
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    currentLang() {
      return this.locales.filter(elem => elem.code == this.lang)[0];
    },
    availableLocales() {
      return this.locales.filter(elem => elem.code != this.lang);
    }
  },
  methods: {
    toggleLangs() {
      this.show = !this.show;
    }
  }
};
</script>

<style scoped>
.language-selector {
  position: relative;
  width: 180px;
  text-align: center;
  z-index: 111111;
}
a {
  text-decoration: none;
  font-size: 13px;
}
a.current-language {
  display: block;
}
a.current-language .triangle {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
}
.language-options {
  position: absolute;
  top: 22px;
  right: 0;
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.19);
  width: 180px;
}
.language-options a {
  padding: 4px 8px;
  display: block;
  border-top: solid 1px #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue